export default [
  
  {
    path: '/gkvip/index',
    name: 'index',
    component: () => import('@/views/gkvip/index'),
    meta: {
      title: '会员支付'
    }
  },
]
